import { useState, useEffect } from 'react'
import { Api } from 'utilities'
import { ImageLabelLineProps } from 'components/shared'
import { SelectOption } from 'components/shared/Select'

interface StoreResponse {
  id: number
  name: string
  mainImage?: {
    url?: string
  }
  images?: Array<{
    url?: string
  }>
  [key: string]: any
}

export const useGetStores = (token: string) => {
  const [stores, setStores] = useState<SelectOption<number, ImageLabelLineProps>[]>([])
  const [storesRawData, setStoresRawData] = useState<StoreResponse[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!token) return
    setIsLoading(true)
    setError(null)

    Api.get<StoreResponse[]>('/stores/current-user', 'marketPlaceApi', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        setStoresRawData(response)
        const transformedStores: SelectOption<number, ImageLabelLineProps>[] = response.map((store) => {
          // Get image URL from mainImage or first image, or use empty string
          const imgSrc = store.mainImage?.url || store.images?.[0]?.url || ''

          return {
            label: store.name || '',
            value: store.id,
            customComponentProps: {
              imgSrc,
              label: store.name || ''
            }
          }
        })

        setStores(transformedStores)
        setIsLoading(false)
      })
      .catch((err) => {
        setError(err)
        setIsLoading(false)
        console.error('Error fetching stores:', err)
      })
  }, [token])

  return { stores, storesRawData, isLoading, error }
}
